import Auth from './Auth';
import ManagerDashboard from 'stores/ui/manager/Dashboard';
import Users from 'stores/ui/admin/Users';
import Prescribers from 'stores/ui/admin/Prescribers';
import Practices from 'stores/ui/admin/Practices';
import ItemReminders from 'stores/ui/admin/ItemReminders';
import Reminders from 'stores/ui/manager/Reminders';
import UserDashboard from 'stores/ui/user/Dashboard';
import UiShared from 'stores/UiShared';
import ConsentSignature from 'stores/ui/manager/ConsentSignature';

export default class RootStore {
	auth: Auth = null;
	uiShared: UiShared = null;

	ui = {
		manager: {
			dashboard: null,
			consentSignature: null,
			reminders: null
		},
		user: {
			dashboard: null
		},
		admin: {
			users: null,
			practices: null,
			prescribers: null,
			itemReminders: null
		}
	};

	constructor() {
		this.auth = new Auth(this);
		this.uiShared = new UiShared(this);
		this.ui.admin.users = new Users(this);
		this.ui.admin.practices = new Practices(this);
		this.ui.admin.prescribers = new Prescribers(this);
		this.ui.admin.itemReminders = new ItemReminders(this);
		this.ui.manager.dashboard = new ManagerDashboard(this);
		this.ui.manager.consentSignature = new ConsentSignature();
		this.ui.manager.reminders = new Reminders(this);
		this.ui.user.dashboard = new UserDashboard(this);
	}

	init(): Promise {
		return this.auth.hydrate().then(() => {
			if (this.auth?.user?.role !== 'admin') {
				return this.ui.manager.consentSignature.load();
			}
		});
	}

	clear() {
		this.uiShared = new UiShared(this);
		this.ui.manager.dashboard = new ManagerDashboard(this);
		this.ui.admin.users = new Users(this);
		this.ui.admin.practices = new Practices(this);
		this.ui.admin.prescribers = new Prescribers(this);
		this.ui.admin.itemReminders = new ItemReminders(this);
		this.ui.user.dashboard = new UserDashboard(this);
		this.ui.manager.consentSignature = new ConsentSignature();
		this.ui.manager.reminders = new Reminders(this);
	}
}

const rootStore = new RootStore();

export { rootStore };



// WEBPACK FOOTER //
// ./src/stores/RootStore.js